import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Checkbox,
  FormControlLabel,
  TextField,
  Radio,
  RadioGroup,
  FormControl,
  FormLabel,
  TableCell,
} from "@mui/material";
import MUIDataTable, { MUIDataTableOptions } from "mui-datatables";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { Box } from "@mui/material";
import axios from "axios";
import { toast } from "react-toastify";
import ImportPopup from "./ImportPopup";
import API_BASE_URL from "../utilities/ApiConfig";
import formatDate from "../utilities/formatDate";
import ApiLoader from "./ApiLoader";
import { faO } from "@fortawesome/free-solid-svg-icons";
import { useSelector } from "react-redux";

const TodaysAppointmentsTable = () => {
  const [showVoucher, setShowVoucher] = useState(false);
  const [voucherData, setVoucherData] = useState(false);
  const [openPopup, setOpenPopup] = useState(false);
  const [openTokenPopup, setOpenTokenPopup] = useState(false);
  const { userDetails } = useSelector((state) => state.auth);
  console.log("user login data", userDetails);

  const importPDEinitialValues = {
    pdeId: "",
    bookno: "",
    dCode: userDetails?.dcode,
    sroCode: userDetails?.srocode,
    commFlag: false,
    postponed: false,
    section: "",
    reason: "",
    minuteBookNo: "",
  };

  const [importPdeParams, setImportPdeParams] = useState(
    importPDEinitialValues
  );
  const [loading, setLoading] = useState(false);
  const [todaysPDEAppointmentsList, setTodaysPDEAppointmentsList] = useState(
    []
  );
  const [selectedPDEAppointmentsDetails, setSelectedPDEAppointmentsDetails] =
    useState([]);
  const [deedTypeList, setDeedTypeList] = useState([]);
  const [tokenNo, setTokenNo] = useState("");
  const [refresh, setRefresh] = useState(0);

  const handleOpenPopup = async (PDE_ID) => {
    debugger;
    try {
      setLoading(true);
      setImportPdeParams(importPDEinitialValues);
      const response = await axios.get(
        `${API_BASE_URL}/Registration/get_pde_details_by_pde_id/${PDE_ID}`
      );
      console.log("pde details using pde id", response.data);
      if (response?.data?.statusResponse?.statusCode === 200) {
        setSelectedPDEAppointmentsDetails(response?.data?.appointments[0]);
        const { dcode, srocode, pdE_ID, bookno } =
          response?.data?.appointments[0];
        console.log(response?.data?.appointments[0]);
        setImportPdeParams((prevParams) => ({
          ...prevParams,
          dCode: userDetails?.dcode,
          sroCode: userDetails?.srocode,
          pdeId: pdE_ID,
          bookno: bookno,
        }));
        setOpenPopup(true);
        console.log(PDE_ID);
      } else {
        toast.error(response?.data?.statusResponse?.status);
      }
    } catch (error) {
      toast.error("Due to unexpected error failed to get pde details");
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const handleClosePopup = () => {
    console.log("handle close popup started");
    setOpenPopup(false);
  };

  const handleCloseTokenPopup = () => {
    setOpenTokenPopup(false);
  };

  const handleGetTodaysPdeList = async () => {
    debugger;
    try {
      setLoading(true);
      const response = await axios.get(
        `${API_BASE_URL}/Registration/get_todays_all_entiries_for_verification_using_dcode_and_srocode/${userDetails?.dcode}/${userDetails?.srocode}`
      );
      console.log(response.data);
      if (response.data.statusResponse.statusCode === 200) {
        setTodaysPDEAppointmentsList(response?.data?.appointments);
      } else {
        toast.error(response?.data?.statusResponse?.status);
      }
    } catch (error) {
      toast.error(
        "Failed to fetch Todays Data Due to Unexpected error Please Try Again"
      );
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const handleGetDeedType = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${API_BASE_URL}/Master/deed_master_data_get`
      );
      console.log(response.data);
      if (response.data.statusResponse.statusCode === 200) {
        setDeedTypeList(response?.data?.deedMasterList);
      } else {
        toast.error(response?.data?.statusResponse?.status);
      }
    } catch (error) {
      toast.error(
        "Failed to fetch Deed Type Data Due to Unexpected error Please Try Again"
      );
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const todaysPDEAppointmentsListTableData = todaysPDEAppointmentsList.map(
    (appointment) => {
      const deed = deedTypeList.find(
        (deed) => deed.deedCode === appointment.deedcode
      );
      return deed ? { ...appointment, deedName: deed.deedName } : appointment;
    }
  );

  console.log(todaysPDEAppointmentsListTableData);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setImportPdeParams({ ...importPdeParams, [name]: value });
  };

  const handleImportPDE = async (e) => {
    debugger;
    e.preventDefault();
    try {
      setLoading(true);
      const response = await axios.post(
        `${API_BASE_URL}/Registration/import_PDE_from_eregistration_to_crsdatabase`,
        importPdeParams
      );
      console.log(response.data);
      if (response.data.statusCode === 200) {
        toast.success(response?.data?.status);
        setTokenNo(response?.data?.tokenNo);
        setOpenTokenPopup(true);
        setOpenPopup(false);
        setRefresh(refresh + 1);
      } else {
        toast.error(response?.data?.importPdeError?.errorMessage);
      }
    } catch (error) {
      console.log(error);
      toast.error("due to Unexpected error failed to import PDE");
    } finally {
      setLoading(false);
    }
  };

  const handleCheckBoxChange = (e) => {
    const { name, checked } = e.target;
    setImportPdeParams({ ...importPdeParams, [name]: checked });
  };

  const handleRadioButtonChange = (e) => {
    const { name, value } = e.target;
    setImportPdeParams({ ...importPdeParams, [name]: value });
  };

  useEffect(() => {
    handleGetDeedType();
    handleGetTodaysPdeList();
  }, []);

  useEffect(() => {
    handleGetTodaysPdeList();
  }, [refresh]);

  // const handleGetVoucherData = async (voucherId) => {
  //   try {
  //     const url = `${API_BASE_URL}/Accounts/get_voucher_details_by_voucher_id/${voucherId}`;
  //     const response = await axios.get(url);
  //     console.log('get data from the table', response.data);
  //     //   setVoucherData(response.data);
  //     //   setShowVoucher(true);
  //   } catch (err) {
  //     toast.error("Failed to Load Expense Voucher.");
  //   }
  // };

  const TableData = todaysPDEAppointmentsListTableData?.map((item, index) => ({
    ...item,
    sn: index + 1,
  }));

  // const columns = [
  //   {
  //     name: "sn",
  //     label: "Serial No",
  //     options: {
  //       filter: false,
  //       sort: true,
  //       customBodyRender: (value) => <div className="text-center">{value}</div>,
  //     },
  //   },
  //   {
  //     name: "pdE_ID",
  //     label: "PDE ID",
  //     options: {
  //       filter: false,
  //       sort: true,
  //       customBodyRender: (value) => <div className="text-start">{value}</div>,
  //     },
  //   },
  //   {
  //     name: "deedName",
  //     label: "DEED TYPE",
  //     options: {
  //       filter: false,
  //       sort: true,
  //       customBodyRender: (value) => <div className="text-start">{value}</div>,
  //     },
  //   },
  //   {
  //     name: "appointmentDate",
  //     label: "APPOINTMENT DATE",
  //     options: {
  //       filter: false,
  //       sort: true,
  //       customBodyRender: (value) => (
  //         <div className="text-start">{formatDate(value, "dd/MM/yyyy")}</div>
  //       ),
  //     },
  //   },
  //   {
  //     name: "appointmentType",
  //     label: "APPOINTMENT TYPE",
  //     options: {
  //       filter: false,
  //       sort: true,
  //       customBodyRender: (value) => (
  //         <div className="text-start">
  //           {/* {value === "V" ? "Virtual" : "Physical"} */}
  //           {value === "P"
  //             ? "Physical"
  //             : value === "L"
  //             ? "Paperless"
  //             : value === "V"
  //             ? "Virtual"
  //             : ""}
  //         </div>
  //       ),
  //     },
  //   },

  //   {
  //     name: "pdE_ID",
  //     label: "ACTION",
  //     options: {
  //       filter: false,
  //       sort: true,
  //       customBodyRender: (value) => (
  //         <button
  //           className="capitalize px-5 py-1 text-start text-sm rounded-md cursor-pointer bg-primary-600 text-white"
  //           onClick={() => {
  //             handleOpenPopup(value);
  //           }}
  //         >
  //           Verify
  //         </button>
  //       ),
  //     },
  //   },
  // ];

  // const options = {
  //   selectableRows: "none",
  //   filterType: "dropdown",
  //   elevation: 0,
  //   rowsPerPageOptions: [10, 15, 25, 50],
  //   responsive: "standard",
  //   tableBodyHeight: "auto",
  //   tableBodyMaxHeight: "auto",
  //   download: false, // Disables the default download (CSV export) button
  //   print: false, // Disables the default print button
  //   viewColumns: false, // Disables the default view columns button
  //   search: true, // Enables the default search button
  //   customToolbarSelect: () => null, // Hide default toolbar select (if not needed)
  // };

  // const getMuiTheme = () =>
  //   createTheme({
  //     typography: {
  //       fontFamily: "Poppins",
  //     },
  //     palette: {
  //       background: {
  //         paper: "#ffffff",
  //         default: "#ffffff",
  //       },
  //       mode: "light",
  //     },
  //     components: {
  //       MuiTableCell: {
  //         styleOverrides: {
  //           head: {
  //             backgroundColor: "#ffffff !important",
  //             color: "#929292 !important",
  //             padding: "10px 4px",
  //             borderBottom: "2px solid #ECECEC",
  //             borderRight: "0px solid #ddd",
  //             textAlign: "start",
  //             "& .MuiTableSortLabel-root": {
  //               color: "#000000 !important",
  //               "&.MuiTableSortLabel-active": {
  //                 color: "#000000 !important",
  //               },
  //             },
  //             "& .MuiTableSortLabel-icon": {
  //               color: "#000000 !important",
  //             },
  //             "&:hover": {
  //               color: "#000000 !important",
  //               backgroundColor: "#ffffff !important",
  //             },
  //           },
  //           body: {
  //             padding: "7px 15px",
  //             color: "#000000",
  //             borderBottom: "0px solid #ECECEC",
  //             borderRight: "0px solid #000000",
  //           },
  //           footer: {
  //             padding: "7px 15px",
  //             borderBottom: "0px solid #ECECEC",
  //           },
  //         },
  //       },
  //     },
  //   });

  const headerCellSx = {
    fontFamily: "Poppins",
    textTransform: "uppercase", // keep “DEED TYPE” etc as-is
    backgroundColor: "#ffffff",
    color: "#929292",
    borderBottom: "2px solid #ECECEC",
    padding: "10px 4px",
    fontSize: "0.875rem",
  };

  const columns = [
    {
      name: "sn",
      label: "Serial No",
      options: {
        filter: false,
        sort: true,
        customHeadRender: (colMeta) => (
          <TableCell align="center" sx={headerCellSx}>
            {colMeta.label}
          </TableCell>
        ),
        customBodyRender: (value) => <div className="text-center">{value}</div>,
      },
    },
    {
      name: "pdE_ID",
      label: "PDE ID",
      options: {
        filter: false,
        sort: true,
        customHeadRender: (colMeta) => (
          <TableCell align="center" sx={headerCellSx}>
            {colMeta.label}
          </TableCell>
        ),
        customBodyRender: (value) => <div className="text-center">{value}</div>,
      },
    },
    {
      name: "deedName",
      label: "DEED TYPE",
      options: {
        filter: false,
        sort: true,
        customHeadRender: (colMeta) => (
          <TableCell align="center" sx={headerCellSx}>
            {colMeta.label}
          </TableCell>
        ),
        customBodyRender: (value) => <div className="text-center">{value}</div>,
      },
    },
    {
      name: "appointmentDate",
      label: "APPOINTMENT DATE",
      options: {
        filter: false,
        sort: true,
        customHeadRender: (colMeta) => (
          <TableCell align="center" sx={headerCellSx}>
            {colMeta.label}
          </TableCell>
        ),
        customBodyRender: (value) => (
          <div className="text-center">{formatDate(value, "dd/MM/yyyy")}</div>
        ),
      },
    },
    {
      name: "appointmentType",
      label: "APPOINTMENT TYPE",
      options: {
        filter: false,
        sort: true,
        customHeadRender: (colMeta) => (
          <TableCell align="center" sx={headerCellSx}>
            {colMeta.label}
          </TableCell>
        ),
        customBodyRender: (value) => (
          <div className="text-center">
            {value === "P"
              ? "Physical"
              : value === "L"
              ? "Paperless"
              : value === "V"
              ? "Virtual"
              : ""}
          </div>
        ),
      },
    },
    {
      name: "pdE_ID",
      label: "ACTION",
      options: {
        filter: false,
        sort: true,
        customHeadRender: (colMeta) => (
          <TableCell align="center" sx={headerCellSx}>
            {colMeta.label}
          </TableCell>
        ),
        customBodyRender: (value) => (
          <button
            className="capitalize px-5 py-1 text-center text-sm rounded-md cursor-pointer bg-primary-600 text-white"
            onClick={() => handleOpenPopup(value)}
          >
            Verify
          </button>
        ),
      },
    },
  ];

  const options = {
    selectableRows: "none",
    filterType: "dropdown",
    elevation: 0,
    rowsPerPageOptions: [10, 15, 25, 50],
    responsive: "standard",
    tableBodyHeight: "auto",
    tableBodyMaxHeight: "auto",
    download: false,
    print: false,
    viewColumns: false,
    search: true,
    customToolbarSelect: () => null,
  };

  const getMuiTheme = () =>
    createTheme({
      typography: { fontFamily: "Poppins" },
      palette: {
        background: { paper: "#ffffff", default: "#ffffff" },
        mode: "light",
      },
      components: {
        MuiTableCell: {
          styleOverrides: {
            // center *every* body cell
            body: {
              textAlign: "center",
              padding: "7px 15px",
              color: "#000000",
              borderBottom: "0px solid #ECECEC",
            },
            footer: {
              padding: "7px 15px",
              borderBottom: "0px solid #ECECEC",
            },
          },
        },
      },
    });

  return (
    <>
      {loading && <ApiLoader />}

      <div className="py-5 flex justify-center items-center">
        <Box width="100%">
          <ThemeProvider theme={getMuiTheme()}>
            <MUIDataTable
              title={"Import PDE"}
              data={TableData}
              columns={columns}
              options={options}
            />
          </ThemeProvider>
        </Box>

        <Dialog open={openPopup} maxWidth="sm" fullWidth>
          <DialogTitle>I HAVE VERIFIED PDE READY TO IMPORT PDE</DialogTitle>
          <DialogContent>
            <FormControl component="fieldset" fullWidth>
              <FormControlLabel
                name="commFlag"
                checked={importPdeParams?.commFlag}
                onChange={(e) => {
                  handleCheckBoxChange(e);
                }}
                control={<Checkbox />}
                label="Commission mode"
              />

              <FormControlLabel
                name="postponed"
                checked={importPdeParams?.postponed}
                onChange={(e) => {
                  handleCheckBoxChange(e);
                }}
                control={<Checkbox />}
                label="Postponed mode"
              />

              <FormLabel component="legend" style={{ marginTop: "20px" }}>
                Refer to collector
              </FormLabel>

              {importPdeParams.postponed && (
                <>
                  <RadioGroup
                    value={importPdeParams?.section}
                    onChange={(e) => {
                      handleRadioButtonChange(e);
                    }}
                    name="section"
                    defaultValue="Under Section Stamp Act 33"
                  >
                    <FormControlLabel
                      value="Under Section Stamp Act 33"
                      control={<Radio />}
                      label="Under Section Stamp Act 33"
                    />
                    <FormControlLabel
                      value="Under Section Stamp Act 47A"
                      control={<Radio />}
                      label="Under Section Stamp Act 47A"
                    />
                    <FormControlLabel
                      value="Any Other"
                      control={<Radio />}
                      label="Any Other"
                    />
                  </RadioGroup>

                  <TextField
                    label="Reason"
                    multiline
                    rows={3}
                    variant="outlined"
                    name="reason"
                    value={importPdeParams.reason}
                    onChange={(e) => {
                      handleInputChange(e);
                    }}
                    fullWidth
                    style={{ marginTop: "20px" }}
                  />

                  <TextField
                    label="Minute Book No."
                    variant="outlined"
                    name="minuteBookNo"
                    value={importPdeParams.minuteBookNo}
                    onChange={(e) => {
                      handleInputChange(e);
                    }}
                    fullWidth
                    style={{ marginTop: "20px" }}
                  />
                </>
              )}
            </FormControl>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={handleClosePopup}
              variant="contained"
              color="error"
            >
              Cancel
            </Button>
            <Button
              onClick={(e) => {
                handleImportPDE(e);
              }}
              color="primary"
              variant="contained"
            >
              Import PDE
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog open={openTokenPopup} onClose={handleCloseTokenPopup}>
          <DialogTitle className="bg-gray-800 text-white">
            Popup Title
          </DialogTitle>
          <DialogContent className="bg-white p-4 px-10">
            <p className="text-gray-700 text-bo">Token No : {tokenNo}</p>
          </DialogContent>
          <DialogActions className="bg-gray-100">
            <Button
              onClick={handleCloseTokenPopup}
              className="bg-red-500 hover:bg-red-700 text-white py-1 px-3 rounded"
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </>
  );
};

export default TodaysAppointmentsTable;
